import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../api/client';
import { Layout } from '../components/Layout';

interface CarClass {
  carClassName: string;
}

export const CarClassesPage: React.FC = () => {
  const { data: classesData, isLoading, error } = useQuery({
    queryKey: ['carClasses'],
    queryFn: async () => {
      const response = await apiClient.get<any>('/vehicles/classes');
      return response.data;
    },
  });

  const classes: CarClass[] = classesData?.data || [];

  return (
    <Layout>
      <div className="px-2 py-4">
        <h1 className="text-2xl font-semibold text-gray-900 mb-4">차량 등급 조회</h1>

        {/* Results */}
        <div>
          <div className="flex items-center justify-between mb-3">
            <h2 className="text-lg font-semibold text-gray-900">
              전체 등급
              {classes.length > 0 && <span className="ml-2 text-sm font-normal text-gray-600">({classes.length}개)</span>}
            </h2>
          </div>

          {isLoading ? (
            <div className="bg-white border border-slate-200 rounded-lg px-6 py-12 text-center">
              <div className="inline-block animate-spin rounded-full h-8 w-8 border-b-2 border-slate-600"></div>
              <p className="mt-3 text-slate-600 text-sm">조회 중...</p>
            </div>
          ) : error ? (
            <div className="bg-white border border-slate-200 rounded-lg px-6 py-12 text-center">
              <p className="text-rose-600 text-sm">차량 등급 조회에 실패했습니다.</p>
              <p className="text-sm text-gray-500 mt-2">
                {(error as any)?.response?.data?.detail || (error as Error).message}
              </p>
            </div>
          ) : !classesData || classes.length === 0 ? (
            <div className="bg-white border border-slate-200 rounded-lg px-6 py-12 text-center">
              <svg
                className="mx-auto h-12 w-12 text-gray-400"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                />
              </svg>
              <p className="mt-2 text-slate-500 text-sm">등록된 차량 등급이 없습니다.</p>
            </div>
          ) : (
            <div className="bg-white border border-slate-200 rounded-lg overflow-hidden">
              <table className="min-w-full divide-y divide-gray-200">
                <thead className="bg-gray-50">
                  <tr>
                    <th className="px-4 py-3 text-left text-sm font-medium text-gray-500 uppercase">
                      번호
                    </th>
                    <th className="px-4 py-3 text-left text-sm font-medium text-gray-500 uppercase">
                      차량 등급
                    </th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200">
                  {classes.map((carClass, index) => (
                    <tr key={index} className="hover:bg-gray-50">
                      <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-500">
                        {index + 1}
                      </td>
                      <td className="px-4 py-3 whitespace-nowrap">
                        <span className="px-2 py-0.5 inline-flex text-xs leading-5 font-semibold rounded bg-blue-100 text-blue-700">
                          {carClass.carClassName}
                        </span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </Layout>
  );
};
